<template>
  <section class="order-document-info-modal">
    <v-btn      
      icon
      color="warning"
      title="Informações do Documento"
      @click.prevent.stop="openModal()"
    >
      <v-icon size="15">
        info
      </v-icon>
    </v-btn>

    <OrderDocumentInfoModalPublic 
      v-if="modal.show"
      :order="order"
      :orderToken="orderToken"
      :documentId="documentId"
      @close="closeModal"
    />
  </section>
</template>

<script>
  import OrderDocumentInfoModalPublic from './OrderDocumentInfoModalPublic.vue';
  import { mapActions, mapState } from 'vuex';

  export default {
    name: 'OrderDocumentInfoButtonPublic',
    
    components: {
      OrderDocumentInfoModalPublic
    },

    props: {
      orderToken: {
        type: String,
        required: true
      },
      
      documentId: {
        type: Number,
        required: true
      },
    },  

    data: () => ({
      modal: {
        show: false
      },
    }),

    computed: {
      ...mapState('order', {
        order: 'order'
      })
    },

    methods: {
      closeModal() {
        this.modal.show = false;
        this.fetchOrder(this.orderToken);
        this.$emit('close');
      },

      openModal() {
        this.modal.show = true;        
      },

      ...mapActions('order', { 
        fetchOrder: 'SHOW_PUBLIC'       
      }),
    },
  }
</script>
